/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Item_Invalid_LinkInputs */

const en_task_flow_item_invalid_link = /** @type {(inputs: Task_Flow_Item_Invalid_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page no longer exists`)
};

const pt_br2_task_flow_item_invalid_link = /** @type {(inputs: Task_Flow_Item_Invalid_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página não existe mais`)
};

/**
* | output |
* | --- |
* | "This page no longer exists" |
*
* @param {Task_Flow_Item_Invalid_LinkInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_item_invalid_link = /** @type {((inputs?: Task_Flow_Item_Invalid_LinkInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Item_Invalid_LinkInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_item_invalid_link(inputs)
	return pt_br2_task_flow_item_invalid_link(inputs)
});